// BPP-21166 Below are the Access Controls for the Current loggedin User based on userprofile info as per the Menu List Items.
//Few of menu list items which are universally accessible  meaning accessible to all users are not part of this list.
//These restrictions are purely placed based on the userprofile information namely accessLevel,userType and Producer Type.
export function accessControlList(accessLevel, userType, producerType) {
  let features = {
    commissions: false,
    renewals: false,
    clients: false,
    applications: false,
    reports: false,
    agentConnect: false,
    accountDetails: false,
    cancelAccount:false,
    PCPMCommissions: false,
    brokerAPIs: false,
    chatbotAccess: true,
    newsAndAnnouncement: true,
    authorizations: false,
    delegateVendorAuthorization: false,
  };

  const isAccessLevelFull = (accessLevel?.toUpperCase() === 'FULL');
  if (isAccessLevelFull && (userType === "Primary") && (producerType === "Agency")) {
    features.clients = true;
    features.commissions = true;
    features.renewals = true;
    features.applications = true;
    features.reports = true;
    features.agentConnect = true;
    features.accountDetails = true;
    features.brokerAPIs = true;
    features.authorizations = true;
  }
  else if (isAccessLevelFull && (userType === "Primary") && (producerType === "General Agency")) {
    features.clients = true;
    features.commissions = true;
    features.renewals = true;
    features.applications = true;
    features.reports = true;
    features.agentConnect = true;
    features.accountDetails = true;
    features.brokerAPIs = true;
    features.authorizations = true;
  }
  else if (isAccessLevelFull && (userType === "Primary") && (producerType === "Agent")) {
    features.clients = true;
    features.commissions = true;
    features.renewals = true;
    features.applications = true;
    features.reports = true;
    features.agentConnect = true;
    features.accountDetails = true;
    features.authorizations = true;
  }
  else if (isAccessLevelFull && (userType === "Primary") && (producerType === "Telesales" || producerType === "TELESALES")) {
    features.clients = true;
    features.commissions = false;
    features.renewals = true;
    features.applications = true;
    features.reports = true;
    features.agentConnect = true;
    features.accountDetails = true;
    features.PCPMCommissions = true;
    features.authorizations = true;
  }
  else if ((accessLevel === "Minimum") && (userType === "Delegate") && (producerType === "Telesales" || producerType === "TELESALES")) {
    features.applications = true;
    features.agentConnect = true;
    features.chatbotAccess = true;
  }
  else if (isAccessLevelFull && (userType === "Delegate")) {
    features.clients = true;
    features.commissions = true;
    features.renewals = true;
    features.applications = true;
    features.reports = true;
    features.agentConnect = true;
    features.PCPMCommissions = true;
    features.delegateVendorAuthorization = true;
  }
  else if (isAccessLevelFull && ((userType === "SiteAdministrator"))) {
    features.clients = true;
    features.commissions = true;
    features.renewals = true;
    features.applications = true;
    features.reports = true;
    features.agentConnect = true;
    features.accountDetails = true;
    features.PCPMCommissions = true;
    features.authorizations = true;
  }
  else if ((accessLevel === "Moderate") && (userType === "Delegate")) {
    features.clients = true;
    features.renewals = true;
    features.applications = true;
    features.reports = true;
    features.agentConnect = true;
    features.delegateVendorAuthorization = true;
  }
  else if ((accessLevel === "Minimum") && (userType === "Delegate")) {
    features.applications = true;
    features.agentConnect = true;
    features.chatbotAccess = true; // BPP-115706 - provide contact support to delegates with min access
  } 
  else if (producerType === "HPA") {
    features.applications = true;
    features.accountDetails = true;
    features.reports = true;
    features.chatbotAccess = true;
  }
  else if ((accessLevel === "Minimum") && (userType === "AppAssistor") && (producerType === "Agency")) {
    features.applications = true;
    features.reports = true;
    features.agentConnect = true;
    features.chatbotAccess = false;
  }
  if((producerType == "General Agency" || producerType == "Agency" || producerType == "Agent"|| producerType =="HPA" || producerType =="Telesales" ||
      producerType == "TELESALES") && userType != "SiteAdministrator"  && userType != "Delegate"){
    features.cancelAccount = true;
  }
  if (userType === "Primary") {
    features.PCPMCommissions = true;
  }
  return features;
}